import config from "@~/envConfig";
import { OnlineStockData, Product, ProductListConfig } from "@~/types/types";
import { getVariant } from "@~/contexts/VariantContext/utils";

const API_URL = config.onlineStockBaseUrl;
const API_KEY = config.onlineStockApiKey;

export async function fetchOnlineStockDataForProducts(
  products: Product[],
): Promise<OnlineStockData[]> {
  const skuIds = products
    .map((product) => {
      const variant = getVariant({
        product,
        userSelectedColour: null,
        userSelectedSize: null,
      });
      return variant?.aliases.skuId;
    })
    .filter((skuID) => skuID !== undefined);
  return fetchOnlineStockData(skuIds);
}

export async function fetchOnlineStockData(
  skuIds: string[],
): Promise<OnlineStockData[]> {
  const url = `${API_URL}?key=${API_KEY}&skuIds=${skuIds.join(",")}`;
  const res = await fetch(url, { credentials: "include" });
  if (!res.ok) throw new Error("Error calling Online Stock service");

  return (
    (await res.json().then(({ stocks }) => validateOnlineStockData(stocks))) ??
    []
  );
}

const validateOnlineStockData = (data: unknown): OnlineStockData[] | null => {
  if (!Array.isArray(data)) return null;

  return data.every((item) => {
    if (typeof item !== "object" || item === null) return false;
    const { availabilityStatus, stockMessage, stockQuantity, skuId } = item;
    if (typeof availabilityStatus !== "string") return false;
    if (typeof stockMessage !== "string") return false;
    if (typeof stockQuantity !== "number") return false;
    if (typeof skuId !== "string") return false;
    return true;
  })
    ? data
    : null;
};

export const shouldFetchOnlineStock = (config: ProductListConfig) => {
  return isComponentInConfig("StockMessage", config);
};

const isComponentInConfig = (
  componentName: string,
  config: ProductListConfig,
) => {
  const listOfComponentsInConfig = Object.values(config["product-card-slots"])
    .flat()
    .map(({ name }) => name);

  return listOfComponentsInConfig.includes(componentName);
};
